import * as R from 'remeda';
import { combineEpics } from 'redux-observable';
import { filter, map, pluck } from 'rxjs/operators';
import { isEmbedded } from '../../../constants/config';
import { isNotNullOrUndefined } from '../../../lib/typeGuards';
import { getIDFromString } from '../../../lib/url';
import { confirmEditModeFulfilled } from '../editMode/actions';
import { startValidation } from '../ui/actions';
import { isActionOf, makeEpic } from '../utils';
import { fetchAnnotationStackFulfilled } from './actions';
import { getCachedStack } from './reducer';

const batchStartValidationEpic = makeEpic(action$ =>
  action$.pipe(
    filter(isActionOf(startValidation)),
    pluck('meta', 'annotationsIds'),
    filter(isNotNullOrUndefined),
    map(fetchAnnotationStackFulfilled)
  )
);

const updateStackOnSplitEpic = makeEpic(action$ =>
  action$.pipe(
    filter(isActionOf(confirmEditModeFulfilled)),
    filter(() => !isEmbedded()),
    map(
      ({ payload: { results: annotations }, meta: { currentAnnotationId } }) =>
        [
          R.pipe(
            annotations.map(({ annotation }) => getIDFromString(annotation)),
            R.filter(R.isTruthy)
          ),
          currentAnnotationId,
        ] as const
    ),
    filter(([[id], currentAnnotationId]) => id !== currentAnnotationId),
    map(([ids, currentAnnotationId]) => {
      const cachedStack = getCachedStack();
      const index = cachedStack.findIndex(id => id === currentAnnotationId);

      if (index === -1) {
        return undefined;
      }

      const head = cachedStack.slice(0, index);
      const tail = cachedStack.slice(index + 1);

      return fetchAnnotationStackFulfilled([...head, ...ids, ...tail]);
    }),
    filter(isNotNullOrUndefined)
  )
);

export default combineEpics(batchStartValidationEpic, updateStackOnSplitEpic);
